module.exports = __webpack_public_path__ + "img/treasure-hunt-completed.fbc14033.jpg";